module.exports = __webpack_public_path__ + "static/media/notifications-activer-active-cercle.7041dfe7.png";